import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Box, Grid, IconButton, InputAdornment, InputLabel, Stack, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import { FiInfo } from 'react-icons/fi';
import { LanguageContext } from '../../../../../libs/Context';

const SelectSeat = (props) =>
{
	const { number, seatLimit, handleSet, handleError, error } = props;
	const { language } = useContext(LanguageContext);

	const checkNumRange = (newValue) =>
	{
		if (newValue > seatLimit)
		{
			handleError('participantLimit', 'The number of seats cannot exceed the total number of seats.');
		}
	};

	const handleNumberChange = (event) =>
	{
		let newValue = event.target.value;
		const numericValue = newValue.replace(/\D/g, '');

		if (numericValue !== '' && numericValue.startsWith('0'))
		{
			numericValue.replace(/^0+/, '');
		}

		if (Number(numericValue) > seatLimit)
		{
			newValue = seatLimit;
		}
		else
		{
			newValue = Number(numericValue);
		}
		handleSet('participantLimit', newValue);
		checkNumRange(newValue);
	};

	const handleArrows = (type) =>
	{
		let newVal = number + (type === 'increase' ? 1 : -1);

		if (newVal > seatLimit)
		{
			newVal = seatLimit;
		}
		handleSet('participantLimit', Number(newVal));
		checkNumRange(newVal);
	};

	useEffect(() =>
	{
		checkNumRange(number);
	}, [ seatLimit ]);

	return (
		<Grid item xs={12} sm={6} lg={6}>
			<Stack spacing={1}>
				<InputLabel sx={{ fontSize: 'var(--pixel14)', color: 'var(--black)' }}>{language?.numberof_seats}</InputLabel>
				<TextField
					type='text'
					size='small'
					value={Number(number || 0)}
					onChange={handleNumberChange}
					// onKeyDown={handleKeyDown}
					InputLabelProps={{
						shrink : true
					}}
					sx={{
						'& .MuiInputBase-input' : {
							width       : 'calc(100% - 102px)',
							borderColor : error ? 'var(--red)' : undefined // conditional border color
						}
					}}
					variant='outlined'
					fullWidth
					InputProps={{
						endAdornment : (
							<>
								<Stack direction={'row'} minWidth={'80px'} alignItems={'center'} spacing={1}>
									<Typography variant={'body2'} fontStyle={'italic'}>{language?.outof}</Typography>
									<Typography variant={'body2'} color='var(--txtColorBlackL)'>{seatLimit}</Typography>
								</Stack>
								<InputAdornment position='end'>
									<Box display='flex' flexDirection='column' alignItems='center'>
										<IconButton onClick={() => handleArrows('increase')} sx={{ width: 'var(--pixel10)', height: 'var(--pixel10)' }}>
											<KeyboardArrowUpIcon sx={{ fontSize: 'var(--pixel18)' }} />
										</IconButton>
										<IconButton onClick={() => handleArrows('decrease')} sx={{ width: 'var(--pixel10)', height: 'var(--pixel10)' }}>
											<KeyboardArrowDownIcon sx={{ fontSize: 'var(--pixel18)' }} />
										</IconButton>
									</Box>
								</InputAdornment>
							</>
						)
					}}
					error={error?.participantLimit}
				/>
				{error?.participantLimit &&
					<Box display={'flex'} flexDirection={'row'} gap={1} alignItems={'center'}>
						<FiInfo fontSize='var(--pixel16)' color='var(--warning)'/>
						<Typography sx={{ color: 'var(--warning)', fontSize: 'var(--pixel12)' }}>{error.participantLimit}</Typography>
					</Box>
				}
			</Stack>
		</Grid>
	);
};

export default SelectSeat;